import { Routes } from '@angular/router';

export const questionnaireAnalyticsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./questionnaire-analytics.component').then(
        (m) => m.QuestionnaireAnalyticsComponent,
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'insights',
      },
      {
        path: 'insights',
        loadComponent: () =>
          import('./questionnaire-insights/questionnaire-insights.component').then(
            (m) => m.QuestionnaireInsightsComponent,
          ),
      },
      {
        path: 'summaries',
        loadComponent: () =>
          import('./questionnaire-summaries/questionnaire-summaries.component').then(
            (m) => m.QuestionnaireSummariesComponent,
          ),
      },
      {
        path: 'responses',
        loadComponent: () =>
          import('./questionnaire-responses/questionnaire-responses.component').then(
            (m) => m.QuestionnaireResponsesComponent,
          ),
      },
      {
        path: 'responses/:questionnaireInstanceGuid',
        loadComponent: () =>
          import('./questionnaire-response-detail/questionnaire-response-detail.component').then(
            (m) => m.QuestionnaireResponseDetailComponent,
          ),
      },
    ],
  },
];
